<template>
  <v-card class="mb-3">
    <v-list-item>
      <v-list-item-content>
        <p class="text-left">
          {{$t('priceInfo_title1')}}：
          <span class="float-right">{{ priceinfo.num_selection*this.$store.state.shoplist.shoplistData[0].num_selection_specname }}組</span>
        </p>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="mx-4"></v-divider>
    <v-list-item>
      <v-list-item-content>
        <p class="text-left">
          {{$t('priceInfo_title2')}}：
          <span class="float-right">NT$ {{ priceinfo.num_selection_calprice }}</span>
        </p>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="mx-4"></v-divider>
    <v-list-item>
      <v-list-item-content>
        <p class="text-left">
          {{$t('priceInfo_title3')}}：
          <span class="float-right">NT$ {{ priceinfo.num_selection_fee }}</span>
        </p>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="mx-4"></v-divider>
    <v-list-item>
      <v-list-item-content>
        <p class="text-left">
          {{$t('priceInfo_title4')}}：
          <span class="float-right">NT$ -{{ priceinfo.is_coupon_price }}</span>
        </p>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="mx-4"></v-divider>
    <v-list-item>
      <v-list-item-content>
        <p class="text-left">
          {{$t('priceInfo_title5')}}：
          <span class="float-right">NT$ -{{ priceinfo.is_star_price }}</span>
        </p>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="mx-4"></v-divider>
    <v-list-item>
      <v-list-item-content>
        <p class="text-left">
          {{$t('priceInfo_title6')}}：
          <span class="float-right">NT$ -{{ priceinfo.is_shopmoney_price }}</span>
        </p>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="mx-4"></v-divider>
    <v-list-item>
      <v-list-item-content>
        <p class="text-left">
          {{$t('priceInfo_title7')}}：
          <span class="float-right">NT$ {{ priceinfo.num_selection_calprice + priceinfo.num_selection_fee - priceinfo.is_coupon_price - priceinfo.is_star_price - priceinfo.is_shopmoney_price }}</span>
        </p>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: 'priceInfo',

  data: () => ({
    priceinfo: [],
  }),
  methods: {
    showPrice() {
      if (
        this.$store.state.shoplist.shoplistData !== undefined &&
        this.$store.state.shoplist.shoplistData.length > 0
      ) {
        this.priceinfo = this.$store.state.shoplist.shoplistData[0];
        // console.log(this.priceinfo);
      } else {
        alert('未選取商品');
        window.history.go(-1);
      }
    }
  },
  mounted() {
    this.showPrice();
  },
  watch: {
  },
};
</script>
